<template>
  <div
    v-if="unavailable"
    class="support-notice"
    role="status"
    data-testid="support-unavailable-notice"
  >
    <span class="support-notice__text">{{ $t('support.unavailable') }}</span>
    <button
      type="button"
      class="support-notice__close"
      data-testid="support-unavailable-close"
      :aria-label="$t('support.dismiss')"
      @click="hide"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
// P43-05: the calm message shown when the support widget cannot be reached. It
// states what happened and goes away by itself; nothing else on the page waits
// for it. Mounted once at the shell root (components/App/index.vue).
const AUTO_HIDE_MS = 7000

export default {
  name: 'SupportNotice',
  computed: {
    unavailable() {
      const app = this.$store.state.app
      return !!(app && app.support && app.support.unavailable)
    },
  },
  watch: {
    unavailable: {
      immediate: true,
      handler(now) {
        clearTimeout(this.timer)
        if (now) this.timer = setTimeout(this.hide, AUTO_HIDE_MS)
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    hide() {
      this.$store.dispatch('app/support/hide')
    },
  },
}
</script>

<style lang="scss" scoped>
.support-notice {
  position: fixed;
  right: 16px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 96px);
  left: 16px;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 420px;
  margin: 0 auto;
  padding: 12px 14px 12px 16px;
  border: 1px solid #e0e7ff;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(30, 27, 75, 0.18);
  color: #1e1b4b;
  font-size: 13px;
  line-height: 1.7;

  &__close {
    flex: none;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 50%;
    background: #eef2ff;
    color: #3730a3;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
  }
}

@media (min-width: 768px) {
  .support-notice {
    bottom: 24px;
  }
}
</style>
